import {gql} from "@apollo/client";

export const CREATE_WAIVER = gql`
  mutation CreateWaiver($input: CreateWaiverInput!) {
    createWaiver(input: $input) {
      waiver {
        id
        title
        language
        waiverType
        documentUrl
        content
        createdBy{
            email
        }
      }
    }
  }
`;

export const GET_WAIVERS = gql`
query Waivers($page: Int, $pageSize: Int) {
  waivers(page: $page, pageSize: $pageSize) {
    objects {
        id
        title
        waiverType
        documentUrl
        content
        language
        createdBy{
            email
        }
    }
    page
    pages
    hasNext
    hasPrev
  }
}

`;

export const UPDATE_WAIVER = gql`
  mutation UpdateWaiver($id: ID!, $input: CreateWaiverInput!) {
    updateWaiver(id: $id, input: $input) {
      waiver {
        id
        title
        language
        waiverType
        documentUrl
        content
        createdBy{
            email
        }
      }
    }
  }
`;

export const DELETE_WAIVER = gql`
  mutation DeleteWaiver($id: ID!) {
    deleteWaiver(id: $id) {
      success
    }
  }
`;
